import React from "react";

const FRAMEWORK_LABELS = {
  classification: "PyTorch / timm",
  detection: "YOLO (Ultralytics)",
};

const TrainingMetadataSection = ({ trainingParams, modelType }) => {
  const params = trainingParams || {};
  const framework =
    params.framework ||
    FRAMEWORK_LABELS[modelType] ||
    (modelType === "detection" ? "YOLO (Ultralytics)" : "PyTorch / timm");

  const metaItems = [
    { label: "Framework", value: framework },
    { label: "Epochs", value: params.epochs ?? "-" },
    { label: "Image Size", value: params.imgsz ?? params.imgSize ?? "-" },
    { label: "Batch Size", value: params.batchSize ?? params.batch ?? "-" },
    { label: "Optimizer", value: params.optimizer ?? "-" },
    { label: "Learning Rate", value: params.lr ?? params.learningRate ?? "-" },
    { label: "Patience", value: params.patience ?? "-" },
    { label: "Device", value: params.device ?? params.hardware ?? "-" },
  ];

  return (
    <section className="training-metadata">
      <div className="training-metadata__header">Training Metadata &amp; Logs</div>
      <div className="training-metadata__body">
        <div className="training-metadata__grid">
          <dl className="training-metadata__dl">
            {metaItems.map(({ label, value }) => (
              <React.Fragment key={label}>
                <dt>{label}</dt>
                <dd>{value}</dd>
              </React.Fragment>
            ))}
          </dl>
          <div className="training-metadata__logs">
            <div className="text-muted" style={{ fontSize: "0.9rem", lineHeight: 1.6 }}>
              Training logs summary will be shown here when available.
              <br />
              Use the live log streaming endpoint to populate this section.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingMetadataSection;
